import $ from 'jquery';
import _ from 'lodash';

export default class ScrollEffect {
  constructor(options = {}) {
    this.options = _.defaults(options, {
      windowSizeRate: 0.4,
    });
    this.jobs = [];
    this.$window = $(window);
    this.windowHeight = 0;
    this.updateWindowHeight();
  }
  addAction(pos, action, prepare = () => {}) {
    this.jobs.push({
      pos,
      action,
      prepare,
      isFinished: false,
    });
    return this;
  }
  addElements(selecctor, { animateClass, animateToClass, animateFromClass } = { animateClass: 'animation', animateToClass: 'to', animateFromClass: 'from' }) {
    const $elements = $(selecctor);
    $elements.each((index) => {
      const $content = $elements.eq(index);
      const shift = $content.data('se-shift') || 0;
      this.jobs.push({
        pos: $content.offset().top + shift,
        prepare: () => {
          $content.addClass(animateFromClass);
        },
        action: () => {
          $content
            .on('transitionend -webkit-transitionend animationend -webkit-animationend', () => {
              $content
                .removeClass(animateClass)
                .removeClass(animateFromClass);
            })
            .addClass(animateToClass)
            .addClass(animateClass)
            .remove(animateFromClass);
        },
        isFinished: false,
      });
    });
    return this;
  }
  init() {
    const $root = $(window);
    this.jobs.forEach((job) => {
      job.prepare();
    });
    $root
      .on('resize', _.throttle(this.updateWindowHeight.bind(this), 500))
      .trigger('resize');
    $root
      .on('scroll', _.throttle(() => {
        this.jobs.forEach((job, index) => {
          if (
            !job.isFinished &&
            job.pos < ($root.scrollTop() + (this.windowHeight * (1 - this.options.windowSizeRate)))
          ) {
            this.jobs[index].isFinished = true;
            job.action();
          }
        });
      }, 100))
      .trigger('scroll');
    return this;
  }
  updateWindowHeight() {
    this.windowHeight = this.$window.height();
  }
  forceEmmit() {
    this.jobs.each((job, index) => {
      if (!job.isFinished) {
        this.jobs[index].isFinished = true;
        job.action();
      }
    });
    return this;
  }
}
